import React, { useState } from "react";
import * as Components from "../../../components/all";

import Chart from "react-apexcharts";
import { useNavigate } from "react-router-dom";

import { FaUsers } from "react-icons/fa";
import { RiUserFollowFill } from "react-icons/ri";
import { HiOfficeBuilding } from "react-icons/hi";
import { IoTrendingDownOutline, IoTrendingUpOutline } from "react-icons/io5";

export default function Dashboard() {
	const navigate = useNavigate();
	// eslint-disable-next-line no-unused-vars
	const [loading, setLoading] = useState(false);

	// Dashboard Data
	var dashboardData = {
		totalUsers: 69908,
		customerTrend: 9,
		activeUsers: 45090,
		activeTrend: 36,
		totalPS: 175,
		activePS: 170,
		activity: [30, 40, 25, 50, 49, 21, 70, 51, 50, 49, 21, 70],
		registrations: [23, 12, 54, 61, 32, 56, 81, 19, 54, 61, 32, 50],
		earning: [30, 40, 25, 50, 49, 21, 70, 51, 50, 49, 21, 70],
	};

	// Settings
	var settings = {
		airspaceTrendGraph: {
			options: {
				chart: {
					type: "area",
					stacked: false,
					height: "90%",
					zoom: {
						type: "x",
						enabled: true,
						autoScaleYaxis: true,
					},
					toolbar: {
						autoSelected: "zoom",
						tools: {
							download: true,
							selection: false,
							zoom: false,
							zoomin: true,
							zoomout: true,
							pan: false,
							reset: true,
						},
					},
				},
				dataLabels: {
					enabled: false,
				},
				legend: {
					show: false,
				},
				markers: {
					size: 4,
					colors: undefined,
					strokeColors: "#fff",
					strokeWidth: 0,
					fillOpacity: 1,
					discrete: [],
					shape: "circle",
					showNullDataPoints: true,
					hover: {
						sizeOffset: 3,
					},
				},
				fill: {
					type: "gradient",
					gradient: {
						shadeIntensity: 1,
						inverseColors: false,
						opacityFrom: 0.5,
						opacityTo: 0,
						stops: [0, 90, 100],
					},
				},
				yaxis: {
					labels: {
						formatter: function (val) {
							return (val * 10).toFixed(0);
						},
					},
				},
				xaxis: {
					categories: [
						"Jan",
						"Feb",
						"Mar",
						"Apr",
						"May",
						"Jun",
						"Jul",
						"Aug",
						"Sep",
						"Oct",
						"Nov",
						"Dec",
					],
				},
				stroke: {
					show: true,
					curve: "smooth",
					lineCap: "butt",
					width: 2,
					dashArray: 0,
				},
			},
			series: [
				{
					name: "User Activity",
					data: dashboardData.activity,
				},
				{
					name: "User Registration",
					data: dashboardData.registrations,
				},
			],
		},
		earningTrendGraph: {
			options: {
				chart: {
					type: "bar",
					stacked: false,
					height: "90%",
					zoom: {
						type: "x",
						enabled: true,
						autoScaleYaxis: true,
					},
					toolbar: {
						autoSelected: "zoom",
						tools: {
							download: false,
							selection: false,
							zoom: false,
							zoomin: false,
							zoomout: false,
							pan: false,
							reset: false,
						},
					},
				},
				dataLabels: {
					enabled: false,
				},
				legend: {
					show: false,
				},
				markers: {
					size: 0,
				},
				yaxis: {
					labels: {
						formatter: function (val) {
							return val + "k";
						},
					},
				},
				xaxis: {
					categories: [
						"Jan",
						"Feb",
						"Mar",
						"Apr",
						"May",
						"Jun",
						"Jul",
						"Aug",
						"Sep",
						"Oct",
						"Nov",
						"Dec",
					],
				},
			},
			series: [
				{
					name: "Earning",
					data: dashboardData.earning,
				},
			],
		},
	};

	return loading === true ? (
		<Components.Loader />
	) : (
		<div
			className="Dashboard
            overflow-x-hidden overflow-y-auto 
            h-full
            w-full
            sm:p-3 md:p-5
            flex flex-col
            "
		>
			{/* TOP CARDS ROW */}
			<div className="TOP-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap">
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
                    min-h-[120px] 
					sm:min-w-[300px] flex-1 
                    rounded-md
                    p-5 m-2
                    bg-white 
                    flex flex-col
                    "
				>
					{/* heading */}
					<div className="flex items-center">
						<div
							className="
                            h-6 w-6 
                            flex items-center justify-center
                            rounded-full
                            bg-[#fedddd] 
                            text-[#FA9499]
                            "
						>
							<FaUsers />
						</div>

						<h1 className="ml-2 text-darker">Total Users</h1>
					</div>

					{/* data */}
					<div className="flex items-center justify-between mt-auto">
						<h1 className="text-3xl font-medium tracking-tighter">
							{dashboardData.totalUsers.toLocaleString()}
						</h1>

						<div className="">
							{dashboardData.customerTrend > 0 ? (
								<div className="flex items-center justify-center text-green-400">
									<IoTrendingUpOutline />
									<h1 className="ml-1">{dashboardData.customerTrend}%</h1>
								</div>
							) : (
								<div className="flex items-center justify-center text-red-400">
									<IoTrendingDownOutline />
									<h1 className="ml-1">{dashboardData.customerTrend * -1}%</h1>
								</div>
							)}
							<h1 className="text-[#CCCCCC] text-[10px] font-medium opacity-70">
								in last 7 days
							</h1>
						</div>
					</div>
				</div>

				{/* card 2 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[120px] 
					sm:min-w-[300px] flex-1
                    rounded-md
                    p-5 m-2
                    bg-white 
                    flex flex-col
					"
				>
					{/* heading */}
					<div className="flex items-center">
						<div
							className="
                            h-6 w-6 
                            flex items-center justify-center
                            rounded-full
                            bg-[#dfe6ff] 
                            text-main
                            "
						>
							<RiUserFollowFill />
						</div>

						<h1 className="ml-2 text-darker">Active Users</h1>
					</div>

					{/* data */}
					<div className="flex items-center justify-between mt-auto">
						<h1 className="text-3xl font-medium tracking-tighter">
							{dashboardData.activeUsers.toLocaleString()}
						</h1>

						<div className="">
							{dashboardData.activeTrend > 0 ? (
								<div className="flex items-center justify-center text-green-400">
									<IoTrendingUpOutline />
									<h1 className="ml-1">{dashboardData.activeTrend}%</h1>
								</div>
							) : (
								<div className="flex items-center justify-center text-red-400">
									<IoTrendingDownOutline />
									<h1 className="ml-1">{dashboardData.activeTrend * -1}%</h1>
								</div>
							)}
							<h1 className="text-[#CCCCCC] text-[10px] font-medium opacity-70">
								in last 7 days
							</h1>
						</div>
					</div>
				</div>

				{/* card 3 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[120px] 
					sm:min-w-[300px] flex-1                    rounded-md
                    p-5 m-2
                    bg-white 
                    flex flex-col
                    "
				>
					{/* heading */}
					<div className="flex items-center">
						<div
							className="
                            h-6 w-6 
                            flex items-center justify-center
                            rounded-full
                            bg-[#DBF6ED] 
                            text-[#8DBEAD]
                            "
						>
							<HiOfficeBuilding />
						</div>

						<h1 className="ml-2 text-darker">Parking Spaces</h1>
					</div>

					{/* data */}
					<div className="flex items-center justify-between mt-auto">
						<h1 className="text-3xl font-medium tracking-tighter">
							{dashboardData.totalPS.toLocaleString()}
						</h1>

						<div className="">
							<h1 className="text-[#CCCCCC] text-sm font-medium opacity-70 mr-1">
								Currently Active
							</h1>

							<div className="flex items-center justify-center">
								{dashboardData.activePS > 0 ? (
									<h1 className="ml-1 text-green-400">
										{dashboardData.activePS}
									</h1>
								) : (
									<h1 className="ml-1 text-red-400">
										{dashboardData.activePS}
									</h1>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* BOTTOM CARDS ROW */}
			<div className="BOTTOM-CARDS flex flex-col md:flex-row md:items-stretch md:justify-between md:flex-wrap md:mt-2 flex-1">
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
                    min-h-[380px] sm:min-h-[480px] 
					sm:min-w-[500px] 
					flex-[3] 
					max-sm:max-w-full 
                    p-5 m-2
                    rounded-md
                    bg-white 
                    flex flex-col
                    overflow-hidden
                    "
				>
					{/* heading */}
					<div className="pl-2 pb-7 w-full">
						<div className="flex items-center justify-between">
							<h1 className="text-xl">Air Space Trend</h1>
							<button
								className="text-xs text-main hover:opacity-80"
								onClick={() => navigate("/trends")}
							>
								View Details
							</button>
						</div>
						<p className="text-dark text-sm">
							Trends by user registration and activity
						</p>
					</div>

					{/* data */}
					<div className="w-full flex-1 overflow-hidden">
						<Chart
							options={settings.airspaceTrendGraph.options}
							series={settings.airspaceTrendGraph.series}
							type="area"
							height="100%"
							width="100%"
						/>
					</div>
				</div>

				{/* card 2 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[380px] sm:min-h-[480px] 
					sm:min-w-[400px] 
					flex-[2] 
					max-sm:max-w-full 
                    p-5 m-2
                    rounded-md
                    bg-white 
                    flex flex-col
                    overflow-hidden
					"
				>
					{/* heading */}
					<div className="pl-2 pb-7 w-full">
						<div className="flex items-center justify-between">
							<h1 className="text-xl">Earnings Trend</h1>
							<button
								className="text-xs text-main hover:opacity-80"
								onClick={() => navigate("/revenue")}
							>
								View Details
							</button>
						</div>
					</div>

					{/* data */}
					<div className="w-full flex-1 overflow-hidden">
						<Chart
							options={settings.earningTrendGraph.options}
							series={settings.earningTrendGraph.series}
							type="bar"
							height="100%"
							width="100%"
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
